import React, {useState, useEffect} from 'react';
import {Header, Footer, Breadcrumb} from '../../components';
import {useParams, Link} from 'react-router-dom';
import styled from 'styled-components';
import mapBg from "../../assets/images/map/bg.jpg";

import apiBoardData from '../../dummy/boardData.json';
import {callApi} from "../../api";
import Cookies from "universal-cookie";

function BoardList(props) {
    const cookie = new Cookies();

    const user_id = cookie.get('user_id') !== undefined ? cookie.get('user_id') : null;

    let {type} = useParams();

    let boardTitle;
    if (type === 'notice') {
        boardTitle = '공지사항';
    } else if (type === 'free') {
        boardTitle = '자유게시판';
    } else if (type === 'member') {
        boardTitle = '회원의 소리';
    } else if (type === 'guide') {
        boardTitle = '협회 안내사항';
    } else if (type === 'data') {
        boardTitle = '협회 보도자료';
    } else if (type === 'event') {
        boardTitle = 'EVENT';
    } else if (type === 'gallery') {
        boardTitle = '갤러리';
    } else if (type === 'brochure') {
        boardTitle = '홍보물신청';
    } else {
        boardTitle = '기타';
    }

    const breadcrumb = [{
        id: 1,
        title: boardTitle,
        link: '/board/' + type
    }];

    const [boardData, setBoardData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        // 번호 내림차순
        // apiBoardData.sort(function(a, b) {
        //     return b.number - a.number;
        // });

        callApi('/board/'+type, 'GET' ,{}).then((res) => {
            if (res.success) {
                setBoardData(res.list);
            }
        })

        setIsLoading(true);
    }, [type]);

    return (
        <>
           <Header />

            <StyledContainer>
                <div className="title-wrap">
                    <img src={mapBg} alt="" />
                    <div className="title">
                        <span>{boardTitle}</span>
                    </div>
                </div>

                <Breadcrumb data={breadcrumb} />

                <div className="category">
                    <div></div>
                    <div className="active">{boardTitle}</div>
                    <div></div>
                </div>

                <StyledCategoryContainer>
                    <StyledTable>
                        <thead>
                            <tr>
                                <th className="th-number">번호</th>
                                <th className="th-title">제목</th>
                                <th className="th-writer">글쓴이</th>
                                <th className="th-date">날짜</th>
                                <th className="th-hit">조회</th>
                            </tr>
                        </thead>
                        <tbody>
                                {
                                    isLoading &&
                                    boardData.map((item, index) => {
                                        return (
                                            <tr key={item.id}>
                                                <td className="td-number">{item.number}</td>
                                                <td className="td-title">
                                                    <Link to={"/board/" + type + "/" + item.id}>
                                                        {item.title}
                                                    </Link>
                                                </td>
                                                <td className="td-writer">{item.writer}</td>
                                                <td className="td-date">{item.date.substring(0,10)}</td>
                                                <td className="td-hit">{item.hit}</td>
                                            </tr>
                                        );
                                    })
                                }
                        </tbody>
                    </StyledTable>
                    <StyledWriterButton>
                        {
                            type === 'free' &&
                            <Link to={"/boardwrite/" + type}>
                                글쓰기
                            </Link>
                        }
                        {
                            type === 'member' && user_id &&
                            <Link to={"/boardwrite/" + type}>
                                글쓰기
                            </Link>
                        }
                    </StyledWriterButton>
                </StyledCategoryContainer>
            </StyledContainer>

           <Footer />
        </>
    );
}

const StyledContainer = styled.div`
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    
    br {
        display: none;
    }
    
    .title-wrap {
        position: relative;
        user-select: none;
        
        img {
            width: 100%;
        }
        
        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            font-size: 45px;
            font-weight: 200;
            text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
            
            span {
                font-weight: 600;
            }
        }        
    }
    
    .category {
        max-width: 1050px;
        display: flex;
        margin: 110px auto 30px;
        
        div {
            width: 100%;
            max-width: 440px;
            text-align: center;
            font-size: 24px;
            font-weight: 500;
            color: #434343;
            border-bottom: 2px solid #dcdcdc;
            
            &.active {
                width: 100%;
                max-width: 170px;
                border-bottom: 2px solid #f68b1f;
                padding-bottom: 12px;
            }
        }
    }
    
    @media (max-width: 940px) {
        margin: 60px auto 0;
    }
    
    @media (max-width: 475px) {
        br {
            display: block;
        }
    
        .title-wrap {
            img {
                height: 300px;
                object-fit: cover;
            }
            
            .title {
                font-size: 29px;
                text-align: center;
                width: 85%;
            }
        }
        
        .category {
            margin-top: 45px;
            
            div {
                font-size: 19px;
            }
        }
    }
`;

const StyledCategoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 30px auto 93px;
    max-width: 900px;
    padding: 0 20px;
`;

const StyledTable = styled.table`
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    border-top: 1px solid #d0d0d0;
    border-bottom: none;
    
    thead th {
        font-size: 14px;
        font-weight: normal;
    }
    
    .th-number {
        width: 10%;
    }
    
    .th-title {
        width: 50%;   
    }
    
    .th-writer {
    
    }
    
    .th-date {
        
    }
    
    .th-hit {
        
    }
    
    tbody td {
        font-size: 13px;
        height: 35px;
    }
    
    .td-number {
        text-align: center;
    }
    
    .td-title {
           
    }
    
    .td-writer {
        text-align: center;
    }
    
    .td-date {
        text-align: center;
    }
    
    .td-hit {
        text-align: center;
    }
    
    @media (max-width: 700px) {
        thead th {
            font-size: 12px;
        }
    }
`;

const StyledWriterButton = styled.div`
    width: 100%;
    max-width: 900px;
    margin: 20px auto 0;
    text-align: right;
    
    a {
            margin-top: 10px;
            padding: 10px;
            font-size: 14px;
            background-color: #fff;
            border: 1px solid #dcdcdc;
        }
`;

export default BoardList;